import React from 'react';
import { Reveal, SectionLabel } from './Section';
import { CheckCircle2 } from 'lucide-react';

const POINTS = [
  'Real-time industry projects sourced from Intellectra AI',
  'Internship-style experience on live ML & AI problems',
  'End-to-end: collect, clean, model, deploy, present',
  'Portfolio-ready deliverables you can showcase to employers',
];

const STATS = [
  { v:'7', l:'Module Projects' },
  { v:'2', l:'End-to-End ML Projects' },
  { v:'100%', l:'Real-Time Data' },
];

export default function RealTimeProjects() {
  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <Reveal><SectionLabel>Real-Time Industry Projects & Internship</SectionLabel></Reveal>
        <div className="grid lg:grid-cols-[1.2fr_1fr] gap-14 mt-8">
          <div>
            <Reveal delay={0.05}>
              <h2 className="font-display text-[42px] sm:text-[56px] lg:text-[62px] leading-[1.02] font-semibold text-[#293891]">
                Real experience, before your <span className="text-[#E63329]">first job.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-6 max-w-lg text-[15px] leading-relaxed text-[#293891]/75">
                Learn the way real data science teams work — on live problem statements, with real data, ML pipelines and deadlines. Your project work doubles as genuine industry experience.
              </p>
            </Reveal>
            <div className="mt-10 space-y-4">
              {POINTS.map((p,i) => (
                <Reveal key={p} delay={i*0.06}>
                  <div className="flex items-start gap-3">
                    <CheckCircle2 className="text-[#E63329] shrink-0 mt-0.5" size={20}/>
                    <p className="text-[14px] text-[#293891]/80">{p}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          <div className="bg-[#F4F5FB] border border-[#293891]/10 rounded-3xl p-8 lg:p-10">
            <div className="text-[11px] tracking-[0.25em] uppercase font-semibold text-[#293891]/70">By the numbers</div>
            <div className="mt-8 space-y-8">
              {STATS.map((s,i) => (
                <Reveal key={s.l} delay={i*0.1}>
                  <div className="flex items-end gap-6 border-b border-[#293891]/10 pb-6 last:border-0 last:pb-0">
                    <div className="font-display text-[64px] leading-none font-semibold text-[#293891]">{s.v}</div>
                    <div className="text-[14px] font-medium text-[#293891]/70 pb-2">{s.l}</div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
